module.exports = __webpack_public_path__ + "static/media/churrasqueira.fa146b42.jpeg";